var $10734c9823e547c0$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "moins d’une seconde",
        other: "moins de {{count}} secondes"
    },
    xSeconds: {
        one: "1 seconde",
        other: "{{count}} secondes"
    },
    halfAMinute: "30 secondes",
    lessThanXMinutes: {
        one: "moins d’une minute",
        other: "moins de {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "environ 1 heure",
        other: "environ {{count}} heures"
    },
    xHours: {
        one: "1 heure",
        other: "{{count}} heures"
    },
    xDays: {
        one: "1 jour",
        other: "{{count}} jours"
    },
    aboutXWeeks: {
        one: "environ 1 semaine",
        other: "environ {{count}} semaines"
    },
    xWeeks: {
        one: "1 semaine",
        other: "{{count}} semaines"
    },
    aboutXMonths: {
        one: "environ 1 mois",
        other: "environ {{count}} mois"
    },
    xMonths: {
        one: "1 mois",
        other: "{{count}} mois"
    },
    aboutXYears: {
        one: "environ 1 an",
        other: "environ {{count}} ans"
    },
    xYears: {
        one: "1 an",
        other: "{{count}} ans"
    },
    overXYears: {
        one: "plus d’un an",
        other: "plus de {{count}} ans"
    },
    almostXYears: {
        one: "presqu’un an",
        other: "presque {{count}} ans"
    }
};
var $10734c9823e547c0$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var form = $10734c9823e547c0$var$formatDistanceLocale[token];
    if (typeof form === "string") result = form;
    else if (count === 1) result = form.one;
    else result = form.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "dans " + result;
        else return "il y a " + result;
    }
    return result;
};
var $10734c9823e547c0$export$2e2bcd8739ae039 = $10734c9823e547c0$var$formatDistance;


function $05b7040d79e43f9d$export$2e2bcd8739ae039(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}


var $8d225767632dff80$var$dateFormats = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd/MM/y"
};
var $8d225767632dff80$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $8d225767632dff80$var$dateTimeFormats = {
    full: "{{date}} '\xe0' {{time}}",
    long: "{{date}} '\xe0' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $8d225767632dff80$var$formatLong = {
    date: (0, $05b7040d79e43f9d$export$2e2bcd8739ae039)({
        formats: $8d225767632dff80$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $05b7040d79e43f9d$export$2e2bcd8739ae039)({
        formats: $8d225767632dff80$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $05b7040d79e43f9d$export$2e2bcd8739ae039)({
        formats: $8d225767632dff80$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $8d225767632dff80$export$2e2bcd8739ae039 = $8d225767632dff80$var$formatLong;


var $9b2416f8bd9ccacb$var$formatRelativeLocale = {
    lastWeek: "eeee 'dernier \xe0' p",
    yesterday: "'hier \xe0' p",
    today: "'aujourd’hui \xe0' p",
    tomorrow: "'demain \xe0' p'",
    nextWeek: "eeee 'prochain \xe0' p",
    other: "P"
};
var $9b2416f8bd9ccacb$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $9b2416f8bd9ccacb$var$formatRelativeLocale[token];
};
var $9b2416f8bd9ccacb$export$2e2bcd8739ae039 = $9b2416f8bd9ccacb$var$formatRelative;


function $eda89c8f88184c82$export$2e2bcd8739ae039(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : "standalone";
        var valuesArray;
        if (context === "formatting" && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}


var $90897b15d7b593c8$var$eraValues = {
    narrow: [
        "av. J.-C",
        "ap. J.-C"
    ],
    abbreviated: [
        "av. J.-C",
        "ap. J.-C"
    ],
    wide: [
        "avant J\xe9sus-Christ",
        "apr\xe8s J\xe9sus-Christ"
    ]
};
var $90897b15d7b593c8$var$quarterValues = {
    narrow: [
        "T1",
        "T2",
        "T3",
        "T4"
    ],
    abbreviated: [
        "1er trim.",
        "2\xe8me trim.",
        "3\xe8me trim.",
        "4\xe8me trim."
    ],
    wide: [
        "1er trimestre",
        "2\xe8me trimestre",
        "3\xe8me trimestre",
        "4\xe8me trimestre"
    ]
};
var $90897b15d7b593c8$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "janv.",
        "f\xe9vr.",
        "mars",
        "avr.",
        "mai",
        "juin",
        "juil.",
        "ao\xfbt",
        "sept.",
        "oct.",
        "nov.",
        "d\xe9c."
    ],
    wide: [
        "janvier",
        "f\xe9vrier",
        "mars",
        "avril",
        "mai",
        "juin",
        "juillet",
        "ao\xfbt",
        "septembre",
        "octobre",
        "novembre",
        "d\xe9cembre"
    ]
};
var $90897b15d7b593c8$var$dayValues = {
    narrow: [
        "D",
        "L",
        "M",
        "M",
        "J",
        "V",
        "S"
    ],
    short: [
        "di",
        "lu",
        "ma",
        "me",
        "je",
        "ve",
        "sa"
    ],
    abbreviated: [
        "dim.",
        "lun.",
        "mar.",
        "mer.",
        "jeu.",
        "ven.",
        "sam."
    ],
    wide: [
        "dimanche",
        "lundi",
        "mardi",
        "mercredi",
        "jeudi",
        "vendredi",
        "samedi"
    ]
};
var $90897b15d7b593c8$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "minuit",
        noon: "midi",
        morning: "mat.",
        afternoon: "ap.m.",
        evening: "soir",
        night: "mat."
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "minuit",
        noon: "midi",
        morning: "matin",
        afternoon: "apr\xe8s-midi",
        evening: "soir",
        night: "matin"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "minuit",
        noon: "midi",
        morning: "du matin",
        afternoon: "de l’apr\xe8s-midi",
        evening: "du soir",
        night: "du matin"
    }
};
var $90897b15d7b593c8$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = options === null || options === void 0 ? void 0 : options.unit;
    if (number === 0) return "0";
    var feminineUnits = [
        "year",
        "week",
        "hour",
        "minute",
        "second"
    ];
    var suffix;
    if (number === 1) suffix = unit && feminineUnits.includes(unit) ? "\xe8re" : "er";
    else suffix = "\xe8me";
    return number + suffix;
};
var $90897b15d7b593c8$var$localize = {
    ordinalNumber: $90897b15d7b593c8$var$ordinalNumber,
    era: (0, $eda89c8f88184c82$export$2e2bcd8739ae039)({
        values: $90897b15d7b593c8$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $eda89c8f88184c82$export$2e2bcd8739ae039)({
        values: $90897b15d7b593c8$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $eda89c8f88184c82$export$2e2bcd8739ae039)({
        values: $90897b15d7b593c8$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $eda89c8f88184c82$export$2e2bcd8739ae039)({
        values: $90897b15d7b593c8$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $eda89c8f88184c82$export$2e2bcd8739ae039)({
        values: $90897b15d7b593c8$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};
var $90897b15d7b593c8$export$2e2bcd8739ae039 = $90897b15d7b593c8$var$localize;


function $c309fdccb9ef673a$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $c309fdccb9ef673a$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $c309fdccb9ef673a$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $c309fdccb9ef673a$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $c309fdccb9ef673a$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}


function $56621c36efca199b$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}


var $46171d1becc06710$var$matchOrdinalNumberPattern = /^(\d+)(ième|ère|ème|er|e)?/i;
var $46171d1becc06710$var$parseOrdinalNumberPattern = /\d+/i;
var $46171d1becc06710$var$matchEraPatterns = {
    narrow: /^(av\.J\.C|ap\.J\.C|ap\.J\.-C)/i,
    abbreviated: /^(av\.J\.-C|av\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
    wide: /^(avant Jésus-Christ|après Jésus-Christ)/i
};
var $46171d1becc06710$var$parseEraPatterns = {
    any: [
        /^av/i,
        /^ap/i
    ]
};
var $46171d1becc06710$var$matchQuarterPatterns = {
    narrow: /^T?[1234]/i,
    abbreviated: /^[1234](er|ème|e)? trim\.?/i,
    wide: /^[1234](er|ème|e)? trimestre/i
};
var $46171d1becc06710$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $46171d1becc06710$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(janv|févr|mars|avr|mai|juin|juill|juil|août|sept|oct|nov|déc)\.?/i,
    wide: /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i
};
var $46171d1becc06710$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^av/i,
        /^ma/i,
        /^juin/i,
        /^juil/i,
        /^ao/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $46171d1becc06710$var$matchDayPatterns = {
    narrow: /^[lmjvsd]/i,
    short: /^(di|lu|ma|me|je|ve|sa)/i,
    abbreviated: /^(dim|lun|mar|mer|jeu|ven|sam)\.?/i,
    wide: /^(dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi)/i
};
var $46171d1becc06710$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^j/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^di/i,
        /^lu/i,
        /^ma/i,
        /^me/i,
        /^je/i,
        /^ve/i,
        /^sa/i
    ]
};
var $46171d1becc06710$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|minuit|midi|mat\.?|ap\.?m\.?|soir|nuit)/i,
    any: /^([ap]\.?\s?m\.?|du matin|de l'après[-\s]midi|du soir|de la nuit)/i
};
var $46171d1becc06710$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^min/i,
        noon: /^mid/i,
        morning: /mat/i,
        afternoon: /ap/i,
        evening: /soir/i,
        night: /nuit/i
    }
};
var $46171d1becc06710$var$match = {
    ordinalNumber: (0, $56621c36efca199b$export$2e2bcd8739ae039)({
        matchPattern: $46171d1becc06710$var$matchOrdinalNumberPattern,
        parsePattern: $46171d1becc06710$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value);
        }
    }),
    era: (0, $c309fdccb9ef673a$export$2e2bcd8739ae039)({
        matchPatterns: $46171d1becc06710$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $46171d1becc06710$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c309fdccb9ef673a$export$2e2bcd8739ae039)({
        matchPatterns: $46171d1becc06710$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $46171d1becc06710$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $c309fdccb9ef673a$export$2e2bcd8739ae039)({
        matchPatterns: $46171d1becc06710$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $46171d1becc06710$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c309fdccb9ef673a$export$2e2bcd8739ae039)({
        matchPatterns: $46171d1becc06710$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $46171d1becc06710$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c309fdccb9ef673a$export$2e2bcd8739ae039)({
        matchPatterns: $46171d1becc06710$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $46171d1becc06710$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $46171d1becc06710$export$2e2bcd8739ae039 = $46171d1becc06710$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary French locale.
 * @language French
 * @iso-639-2 fra
 * @author Jean Dupouy [@izeau]{@link https://github.com/izeau}
 * @author François B [@fbonzon]{@link https://github.com/fbonzon}
 */ var $430cfc3649ba6f68$var$locale = {
    code: "fr",
    formatDistance: (0, $10734c9823e547c0$export$2e2bcd8739ae039),
    formatLong: (0, $8d225767632dff80$export$2e2bcd8739ae039),
    formatRelative: (0, $9b2416f8bd9ccacb$export$2e2bcd8739ae039),
    localize: (0, $90897b15d7b593c8$export$2e2bcd8739ae039),
    match: (0, $46171d1becc06710$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $430cfc3649ba6f68$export$2e2bcd8739ae039 = $430cfc3649ba6f68$var$locale;


var $841e9d07a822f4bf$require$fr = $430cfc3649ba6f68$export$2e2bcd8739ae039;
// 10.02 Destrukturyzacja i operator spread
console.log("destrukturyzacja + spread operator");
const $841e9d07a822f4bf$var$person = {
    name: "Pawel",
    age: "37"
};
console.log($841e9d07a822f4bf$var$person.name);
console.log($841e9d07a822f4bf$var$person.age);
const { name: $841e9d07a822f4bf$var$name, age: $841e9d07a822f4bf$var$age } = $841e9d07a822f4bf$var$person;
console.log($841e9d07a822f4bf$var$name);
console.log($841e9d07a822f4bf$var$age);
const $841e9d07a822f4bf$var$fruits = [
    "apple",
    "orange",
    "strawberry"
];
const $841e9d07a822f4bf$var$vegetables = [
    "carrot",
    "beetroot",
    "tomato"
];
const [$841e9d07a822f4bf$var$firstFruit, , $841e9d07a822f4bf$var$thirdFruit] = $841e9d07a822f4bf$var$fruits;
console.log($841e9d07a822f4bf$var$firstFruit);
console.log($841e9d07a822f4bf$var$thirdFruit);
// spread
const $841e9d07a822f4bf$var$address = {
    city: "Jaworzno",
    contry: "Poland"
};
const $841e9d07a822f4bf$var$personWithAddress = {
    name: $841e9d07a822f4bf$var$person.name,
    city: $841e9d07a822f4bf$var$address.city
};
console.log($841e9d07a822f4bf$var$personWithAddress);
const $841e9d07a822f4bf$var$personWithAddress1 = {
    ...$841e9d07a822f4bf$var$person,
    ...$841e9d07a822f4bf$var$address
};
console.log($841e9d07a822f4bf$var$personWithAddress1);
const $841e9d07a822f4bf$var$fruitsAndVegs = [
    ...$841e9d07a822f4bf$var$fruits,
    ...$841e9d07a822f4bf$var$vegetables,
    "pizza"
];
console.log($841e9d07a822f4bf$var$fruitsAndVegs);
const $841e9d07a822f4bf$var$newFruits = $841e9d07a822f4bf$var$fruits;
console.log($841e9d07a822f4bf$var$fruits);
console.log($841e9d07a822f4bf$var$newFruits);
$841e9d07a822f4bf$var$newFruits.push("banana");
console.log($841e9d07a822f4bf$var$fruits);
console.log($841e9d07a822f4bf$var$newFruits);
const $841e9d07a822f4bf$var$newFruits1 = [
    ...$841e9d07a822f4bf$var$fruits
];
console.log($841e9d07a822f4bf$var$fruits);
console.log($841e9d07a822f4bf$var$newFruits1);
$841e9d07a822f4bf$var$newFruits.push("banana");
console.log($841e9d07a822f4bf$var$fruits);
console.log($841e9d07a822f4bf$var$newFruits1);


//# sourceMappingURL=index.261b6f08.js.map
